import { jsxs as a, jsx as i } from "react/jsx-runtime";
const p = () => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    width: "24px",
    viewBox: "0 -960 960 960",
    children: [
      /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ a("mask", { id: "hole", children: [
        /* @__PURE__ */ i("circle", { r: "100%", cx: "480", cy: "-480", fill: "white" }),
        /* @__PURE__ */ i("circle", { cx: "480", cy: "-480", r: "288", fill: "black" })
      ] }) }),
      /* @__PURE__ */ i("circle", { cx: "480", cy: "-480", r: "360", fill: "rgb(31 34 38)", mask: "url(#hole)" }),
      /* @__PURE__ */ i(
        "circle",
        {
          className: "Radio-dot",
          cx: "480",
          cy: "-480",
          r: "165",
          fill: "rgb(31 34 38)"
        }
      )
    ]
  }
), m = ({
  id: c,
  name: r,
  value: e,
  label: o,
  checked: d,
  onChange: s,
  disabled: t,
  large: h,
  reference: n,
  testId: l
}) => /* @__PURE__ */ a(
  "div",
  {
    className: `Radio${h ? " Radio--large" : ""}`,
    "data-testid": l ? `${l}-wrapper` : void 0,
    children: [
      /* @__PURE__ */ i(
        "input",
        {
          className: "Radio-button",
          id: c,
          name: r,
          type: "radio",
          value: e,
          checked: d,
          onChange: s,
          disabled: t,
          ref: n,
          "data-testid": l ? `${l}-input` : void 0
        }
      ),
      /* @__PURE__ */ a(
        "label",
        {
          htmlFor: c,
          className: "Radio-label",
          "data-testid": l ? `${l}-label` : void 0,
          children: [
            /* @__PURE__ */ i(p, {}),
            /* @__PURE__ */ i("span", { children: o })
          ]
        }
      )
    ]
  }
);
export {
  m as Radio
};
//# sourceMappingURL=Radio.mjs.map
